import React from "react";
import { HiPencil, HiTrash } from "react-icons/hi2";
import { TanstackSortingFn } from "../../../../utils/TableSorting";
import BaseTable from "../../../ui/CustomTanStackTable/CustomTanStackTable";
import { getDisplayValue } from "../../../../utils/transactionutils";

function PermissionsTableTanstack({ data, onEdit, onDelete }) {
  const [pagination, setPagination] = React.useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const columns = React.useMemo(
    () => [
      {
        accessorKey: "name",
        header: "Permission Name",
        cell: (info) => (
          <div
            className="max-w-[160px] truncate"
            title={getDisplayValue(info.getValue())}
          >
            {getDisplayValue(info.getValue())}
          </div>
        ),
        sortingFn: TanstackSortingFn,
      },
      {
        accessorKey: "description",
        header: "Description",
        cell: (info) => (
          <div
            className="max-w-[120px] truncate"
            title={getDisplayValue(info.getValue())}
          >
            {getDisplayValue(info.getValue())}
          </div>
        ),
        sortingFn: TanstackSortingFn,
      },
      {
        id: "actions",
        header: () => <div className="text-right">Actions</div>,
        cell: (info) => {
          const row = info.row.original;
          return (
            <div className="flex gap-2 justify-end">
              <button
                title="Edit"
                className="text-blue-500 hover:text-blue-700"
                onClick={(e) => {
                  e.stopPropagation();
                  onEdit?.(row);
                }}
              >
                <HiPencil size={16} />
              </button>
              <button
                title="Delete"
                className="text-red-500 hover:text-red-700"
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete?.(row);
                }}
              >
                <HiTrash size={16} />
              </button>
            </div>
          );
        },
        enableSorting: false,
      },
    ],
    [onEdit, onDelete],
  );

  return (
    <BaseTable
      data={data}
      columns={columns}
      pageSize={pagination.pageSize}
      pagination={pagination}
      onPaginationChange={setPagination}
      paginationMode="client"
      emptyMessage="No Permissions Found"
      rowClassName={() =>
        "hover:bg-blue-50 cursor-pointer bg-white-50 h-[50px] "
      }
    />
  );
}

export default PermissionsTableTanstack;
